import apolloClient from 'store/apolloClient';
import apiCall from 'shared/utils/apiCall';
import errorAction from 'shared/utils/errorAction';
import createAsyncAction from 'shared/utils/createAsyncAction';
import { reconnectWS } from 'modules/websocket/WSManager';
import { logout } from 'modules/auth/actions/logout';
import requestsStatuses from 'modules/common/constants/requestsStatuses';

import createAction from './';
import * as services from '../services/refreshJwtToken';

export const UPDATE_JWT_TOKEN = createAsyncAction(createAction('UPDATE_JWT_TOKEN'));
export const UPDATE_JWT_TOKEN_UNPOSSIBLE = createAction('UPDATE_JWT_TOKEN_UNPOSSIBLE');

export const updateJwtTokenUnpossible = () => (dispatch) => dispatch({ type: UPDATE_JWT_TOKEN_UNPOSSIBLE });

export const updateJwtToken = () => (dispatch, getState) => {
  const state = getState();
  const refreshToken = state.session.refreshToken.value;
  const { requestStatus } = state.session.jwtToken;
  const { selectedOrganizationToken } = state.auth.organizations;

  if (!refreshToken || !selectedOrganizationToken || requestStatus === requestsStatuses.failure) {
    if (state.session.sessionInfo.sessionId) dispatch(logout(true, true));
    return dispatch(updateJwtTokenUnpossible());
  }

  dispatch({ type: UPDATE_JWT_TOKEN.pending });

  const apiCallParams = {
    mutation: services.UPDATE_JWT_TOKEN,
    variables: {
      refreshToken,
      orgId: selectedOrganizationToken,
    },
  };

  return apiCall(apolloClient.mutate, apiCallParams)
    .then((response) => {
      const jwtToken = response.data.refreshJwtToken.jwt;

      dispatch({
        type: UPDATE_JWT_TOKEN.success,
        payload: { jwtToken },
      });

      reconnectWS();

      return jwtToken;
    })
    .catch((err) => {
      dispatch(logout(true, true));
      dispatch(errorAction(UPDATE_JWT_TOKEN.failure, err));
      throw err;
    });
};

